import { createContext } from 'react';

const AutoformUiContext = createContext({
    editingState: {},
});

export default AutoformUiContext;
